
(function (window, document, jQuery, undefined) {
    var $ = jQuery.noConflict();
    var $donTabs = $(".site-don .don-tabs");
    $donTabs.each(function () {
        var $navLinks = $(this).find(".don-tabs__nav-link");
        var widestWidth = 0;
        $navLinks.each(function () {
            var thisWidth = $(this).width();
            if (thisWidth > widestWidth) {
                widestWidth = thisWidth;
            }
        });
        $navLinks.each(function () {
            $(this).width(widestWidth);
        });
    });

    var $donTabs2 = $(".don-tabs");

    $donTabs2.each(function () {
        setSameHeightOnTab($(this));
    })

    function setSameHeightOnTab(object) {
        // init vars
        var $navlink = object.find('.don-tabs__nav-link-with-Picture');
        var maxHeight = 0;

        // clear height styles and find max heights
        $navlink.each(function () {
            var $div = $(this);

            maxHeight = $div.height() > maxHeight ? $div.height() : maxHeight;
        });

        if (screen.width <= 1199) {
            return;
        }

        // set max heights
        $navlink.each(function () {
            $div = $(this);
            $div.height(maxHeight);
        });
    };

}) (window, document, jQuery);

